import { AritoIcon, AritoFormV2, BottomActionBarV2, DialogV2, HeaderTabsV2 } from '@/components/custom/erp';
import { BasicInfoTab, GeneralTab, ObjectTab, OtherTab } from './tabs';
import { SearchFormValues, searchSchema } from '../schema';
import { useSearchFieldStates } from '../hooks';

interface InitialSearchDialogProps {
  onClose: () => void;
  onSearch: (values: SearchFormValues) => Promise<void>;
  initialValues: SearchFormValues;
}

export default function SearchDialog({ onClose, onSearch, initialValues }: InitialSearchDialogProps) {
  const searchFieldStates = useSearchFieldStates();
  const { state } = searchFieldStates;

  const handleSubmit = (data: SearchFormValues) => {
    const combinedData: SearchFormValues = {
      ...data,
      // Customer/Supplier related
      ma_kh: state.khachHang?.uuid || null,
      nh_kh1: state.nhomKhachHang1?.uuid || null,
      nh_kh2: state.nhomKhachHang2?.uuid || null,
      nh_kh3: state.nhomKhachHang3?.uuid || null,
      rg_code: state.khuVuc?.uuid || null,

      // Item related
      ma_vt: state.vatTu?.uuid || null,
      nh_vt1: state.nhomVatTu1?.uuid || null,
      nh_vt2: state.nhomVatTu2?.uuid || null,
      nh_vt3: state.nhomVatTu3?.uuid || null,
      ma_kho: state.khoHang?.uuid || null,

      // Object tab fields
      ma_bp: state.boPhan?.uuid || null,
      ma_vv: state.vuViec?.uuid || null,
      ma_hd: state.hopDong?.uuid || null,
      ma_dtt: state.dotThanhToan?.uuid || null,
      ma_ku: state.kheUoc?.uuid || null,
      ma_phi: state.phi?.uuid || null,
      ma_sp: state.sanPham?.uuid || null,
      ma_lsx: state.lenhSanXuat?.uuid || null,
      ma_cp0: state.chiPhi?.uuid || null,

      // Other tab fields
      ma_gd: state.giaoDich?.uuid || null,
      tk_vt: state.taiKhoanVatTu?.uuid || null,
      tk_dt: state.taiKhoanDoanhThu?.uuid || null,
      tk_gv: state.taiKhoanGiaVon?.uuid || null,
      ma_lo: state.lo?.uuid || null,
      ma_vi_tri: state.viTri?.uuid || null
    };
    onSearch(combinedData);
  };

  const tabs = [
    {
      id: 'general',
      label: 'Thông tin chung',
      component: <GeneralTab searchState={searchFieldStates} />
    },
    {
      id: 'object',
      label: 'Đối tượng',
      component: <ObjectTab searchState={searchFieldStates} />
    },
    {
      id: 'other',
      label: 'Khác',
      component: <OtherTab searchState={searchFieldStates} />
    }
  ];

  return (
    <DialogV2
      open={true}
      onClose={onClose}
      title='Bảng kê hóa đơn mua hàng'
      titleIcon={<AritoIcon icon={699} />}
      maxWidth='lg'
    >
      <div className='flex size-full flex-col overflow-hidden'>
        <div className='max-h-[calc(100vh-120px)] flex-1 overflow-auto'>
          <AritoFormV2<SearchFormValues>
            schema={searchSchema}
            initialData={initialValues}
            onSubmit={handleSubmit}
            className='!static !w-full'
            hasAritoActionBar={false}
            headerFields={
              <div className='max-h-[calc(100vh-150px)] w-[800px] min-w-[800px] overflow-y-auto'>
                <BasicInfoTab />

                <HeaderTabsV2 tabs={tabs} />
              </div>
            }
            bottomBar={<BottomActionBarV2 mode='search' onClose={onClose} />}
          />
        </div>
      </div>
    </DialogV2>
  );
}
